<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header :title="item.name" :subtitle="item.due ? (`Due: ${item.due} (${item.due_differential})`) : `Due: Not Set`">
            <template #actions>
                <ui-button-new v-if="item.can_edit" icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new v-if="item.can_delete" icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">
            <!-- Overview. -->
            <ui-data-grid v-if="isActive('overview')">
                <ui-data-grid-item wide label="Description" :value="item.description"></ui-data-grid-item>
                <ui-data-grid-item label="Assigned To" :value="item.getAssignees()"></ui-data-grid-item>
                <ui-data-grid-item v-if="item.complete" label="Completed" :value="item.completed_at"></ui-data-grid-item>
                <ui-data-grid-item v-else-if="item.due" label="Due" :value="`${item.due} (${item.due_differential})`"></ui-data-grid-item>
                <ui-data-grid-item v-else label="Due"></ui-data-grid-item>
                <ui-data-grid-item wide label="Related To" v-if="item.has_package">
                  <a :href="item._links.related" class="text-brand hover:text-brand-light">{{ item.package.common }}</a>
                </ui-data-grid-item>
                <ui-data-grid-item label="Created" :value="`${item.created_at} by ${item.created_by.name}`"></ui-data-grid-item>
                <ui-data-grid-item label="Updated" :value="`${item.updated_at}`"></ui-data-grid-item>

                <div class="text-right lg:col-span-2" v-if="item.can_resolve">
                  <ui-button-new primary v-if="item.completed" @click="item.reopen()">Re-open Task</ui-button-new>
                  <ui-button-new v-else icon="fas fa-check" success @click="item.resolve()">Mark Complete</ui-button-new>
                </div>

            </ui-data-grid>

            <!-- Notes. -->
            <div v-else-if="isActive('notes')">
                <notes :get-url="item.notes_url" :post-url="item.notes_url"></notes>
            </div>

            <!-- Files. -->
            <div v-else-if="isActive('files')">
              <filesystem compact="true" :filesystem-id="item.filesystem_id"></filesystem>
            </div>

        </ui-tabs>

    </ui-container>
</template>

<script>
export default {
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
    },
    data () {
        return {
            tabs: [
                { value: 'overview', label: 'Overview' },
                { value: 'notes', label: 'Notes' },
                { value: 'files', label: 'Files' },
            ],
        }
    },
    methods: {
        openDeleteModal () {
            const title = 'Are you sure you want to delete "' + this.item.name + '"?'
            const description = 'Deleting this task is irreversible. Are you sure you want to delete it?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
    },
}
</script>
